module.exports = __webpack_public_path__ + "media/images/icons/icon_add-8b72491f1c4224ffa6165efc19fd2386.svg";